{
  "version": 1,
  "asset_id": "6631bd6e-6bdd-40c8-a530-987052625247",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/6631bd6e-6bdd-40c8-a530-987052625247/sleeve-gastrectomy-v2-1536.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/6631bd6e-6bdd-40c8-a530-987052625247/sleeve-gastrectomy-v2-1536.webp",
  "original_filename": "sleeve-gastrectomy-v2-1536.webp",
  "size": 110290,
  "content_type": "image/webp",
  "created_at": "2026-09-25T13:06:53Z"
}
